import { Flex, Text, useMantineTheme } from '@mantine/core';
import classes from './AfaDocumentacionCard.module.css';
import { IconFileDescription } from '@tabler/icons-react';

export interface AfaDocumentacionCardProps {
  title: string;
  icon?: React.ReactNode;
  onClick?: () => void;
}

const AfaDocumentacionCard = ({ title, icon, onClick }: AfaDocumentacionCardProps) => {
  const theme = useMantineTheme();

  return (
    <div
      className={classes.card}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if ((e.key === 'Enter' || e.key === ' ') && onClick) {
          e.preventDefault();
          onClick();
        }
      }}
    >
      {/* Zona superior con fondo azul y icono centrado */}
      <div className={classes.topSection}>
        {icon ?? (
          <IconFileDescription
            size={110}
            stroke={1.5}
            color={theme.other.black}
          />
        )}
      </div>

      {/* Franja inferior gris con texto */}
      <div className={classes.bottomSection}>
        <Text fw={500} size="sm" c="white">
          {title}
        </Text>
      </div>
    </div>
  );
};

export default AfaDocumentacionCard;
